import { postApi, getApi, putApi, deleteApi } from "../apis";

// Submit an enquiry form
export const submitEnquiryForm = (enquiryData) => {
    return postApi('/api/enquiries', enquiryData);
};

// Get all enquiry submissions
export const getAllEnquiries = () => {
    return getApi('/api/enquiries');
};

// Update enquiry status
export const updateEnquiryStatus = (id, statusData) => {
    return putApi(`/api/enquiries/${id}`, statusData);
};

// Delete an enquiry record
export const deleteEnquiry = (id) => {
    return deleteApi(`/api/enquiries/${id}`);
};
